export var SelectedPreset;
(function (SelectedPreset) {
    SelectedPreset["CAMPAIGN"] = "campaign";
    SelectedPreset["DATE"] = "date";
    SelectedPreset["SALES"] = "sales";
    SelectedPreset["STORE"] = "store";
    SelectedPreset["STORE_PLACE"] = "store_place";
    SelectedPreset["SELLER"] = "seller";
})(SelectedPreset || (SelectedPreset = {}));
